module.exports = __webpack_public_path__ + "img/intensive-cert-768.a827647d.jpg";